import React, { Component, Fragment, useState } from 'react';
import { Image } from 'antd-mobile'
import { getPoiList } from '../../api/index';
import moduleCss from "./index.module.scss";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }
  // 页面加载完成后，初始化地图，微信配置信息，用户位置
  async componentDidMount() {
    // 2:陈列  3:遗址
    const params = new URLSearchParams(this.props.location.search);
    const type = params.get('type')
    document.title = type == 2 ? '博物馆陈列' : '青龙寺遗址'
    this.setState({
      type
    })
    await this.getList();
  }
  getList() {
    getPoiList().then(res => {
      this.setState({
        list: this.state.type == 2 ? res.data.museum_display_list : res.data.ruins_list,
      });
    })
  }
  goDetail(id) {
    console.log(id)
    console.log(this.props)
    this.props.history.push(`/detail?type=${this.state.type}&id=${id}`)
  }

  render() {
    const { list, type } = this.state;
    return (
      <div>
        <div className={moduleCss.banner}>
          <Image lazy className={moduleCss.img} src={require('../../assets/pic_banner2.png')} alt="" />
        </div>
        <div className={moduleCss.content}>
          <h1 className={moduleCss.title}>{type == 2 ? '陈列' : '遗址'}列表</h1>
          <div className={moduleCss.goodList}>
            {list.map((item, index) => (
              <div className={moduleCss.item} onClick={() => {
                this.goDetail(item.id)
              }}>
                <Image fit='cover' lazy className={moduleCss.img} src={item.banner} alt="" />
                <div className={moduleCss.right}>
                  <h1 className={moduleCss.name}>{item.name}</h1>
                  <p className={moduleCss.desc}>{item.desc}</p>
                </div>
              </div>
            ))

            }

          </div>
        </div>
      </div>
    )
  }
}
export default List